/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import Form, { Label } from "devextreme-react/form";
import LoadPanel from "devextreme-react/load-panel";
import { formatMessage } from "devextreme/localization";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import { useDispatch, useSelector } from "react-redux";
import notify from "devextreme/ui/notify";
import Guid from "devextreme/core/guid";
import UsingIntl from "../../../services/using_intl";
import { axios, getParentPath } from "../../../common";
import PopupConfig from "../../../common/popup";
import { useScreenSize } from "../../../utils/media-query";
import {
  IsPermisionPathRequired,
  showShift,
  getEmployeeByDeclarant,
} from "../../../redux/actions";
import {
  responseMiddleware,
  responseShift,
  responseEmployee,
} from "../../../redux/reducers";
import { useAuth } from "../../../contexts/auth";
import { validateNullOrEmpty } from "../../../middlewares/validate";
import { convertTimeToDateTime, getHmmss } from "../../../services/overtime";
import "./style.scss";

import FormComponent from "./FormComponent";
import EarlyLate from "./EarlyLate";

export default function OvertimeRegistrationDetailBVN() {
  const history = useHistory();
  const formData = useRef({});
  const dispatch = useDispatch();
  const { isXSmall, isSmall } = useScreenSize();
  const { user } = useAuth();
  const { slug } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const { middlewarePath: middleware, loading } =
    useSelector(responseMiddleware);
  const { shift } = useSelector(responseShift);
  const { employeesDeclarant, loadingEmployee } = useSelector(responseEmployee);
  const [employeeOid, setEmployeeOid] = useState(user.EmployeeOid);
  const { handleOpenPopup, handleClosePopup, popupConfig } = PopupConfig();
  const [shiftTimeIn, setShiftTimeIn] = useState();
  const [shiftTimeOut, setShiftTimeOut] = useState();
  const [isAssignedShift, setIsAssignedShift] = useState(true);

  const PARENT_PATH = getParentPath();

  useEffect(() => {
    UsingIntl("P0023");
    dispatch(IsPermisionPathRequired(PARENT_PATH));
  }, [dispatch]);

  useEffect(() => {
    if (middleware) {
      const { NavigateState, CreateState, ReadState } = middleware;
      if (
        (NavigateState !== undefined && !NavigateState) ||
        (ReadState !== undefined && !ReadState) ||
        (CreateState !== undefined && !CreateState)
      ) {
        history.push("/403");
        return;
      }
      if (!user.EmployeeOid) {
        window.location.reload();
        return;
      }
      dispatch(showShift());
      dispatch(getEmployeeByDeclarant(user?.EmployeeOid));
    }
  }, [middleware]);

  useEffect(() => {
    setIsLoading(true);
    const getOvertime = async () => {
      const { data } = await axios.get(`OvertimeRegistration(${slug})`, {
        params: {
          $expand: "Shift,Employee($expand=Department,Position)",
        },
        headers: {
          MappedState: 1,
        },
      });
      formData.current = data;
      formData.current.TimeIn = convertTimeToDateTime(data.TimeIn);
      formData.current.TimeOut = convertTimeToDateTime(data.TimeOut);
      if (data.Shift === null || data.Shift === undefined || !data.Shift) {
        setIsLoading(false);
        return;
      }

      formData.current.Shift = {
        Oid: new Guid(data.Shift.Oid),
        Name: data.Shift.Name,
        TimeIn: convertTimeToDateTime(data.Shift.TimeIn),
        TimeOut: convertTimeToDateTime(data.Shift.TimeOut),
        RestStart: convertTimeToDateTime(data.Shift.RestStart),
        RestEnd: convertTimeToDateTime(data.Shift.RestEnd),
      };
      setIsLoading(false);
    };
    getOvertime();
  }, []);

  const handleCallApi = async (payload) => {
    try {
      await axios.post("OvertimeRegistration", payload, {
        headers: {
          MappedState: 1,
        },
      });
      notify("Registration has been saved", "success", 3000);
      history.push("/overtime/overtime-registration/list");
    } catch (error) {
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  const handleSaveRegistration = async () => {
    const {
      Employee,
      Shift,
      OvertimeDate,
      TimeIn,
      TimeOut,
      TotalHours,
      Reason,
      Oid,
      PaymentMethod,
      IsBeforeShift,
      IsBreakTime,
    } = formData.current;

    if (TotalHours < 0.5) {
      notify("Tổng giờ phải lớn hơn bằng 0.5", "error", 3000);
      return;
    }
    const payload = {
      Employee,
      Shift: {
        Oid: Shift.Oid,
      },
      OvertimeDate,
      Oid,
      TimeIn,
      TimeOut,
      TotalHours,
      Reason,
      PaymentMethod,
      IsBeforeShift,
      IsBreakTime,
    };
    if (typeof TimeIn === "number") {
      payload.TimeIn = getHmmss(new Date(TimeIn));
      formData.current.TimeIn = getHmmss(new Date(TimeIn));
    } else {
      payload.TimeIn = getHmmss(TimeIn);
      formData.current.TimeIn = getHmmss(TimeIn);
    }
    if (typeof TimeOut === "number") {
      payload.TimeOut = getHmmss(new Date(TimeOut));
      formData.current.TimeOut = getHmmss(new Date(TimeOut));
    } else {
      payload.TimeOut = getHmmss(TimeOut);
      formData.current.TimeOut = getHmmss(TimeOut);
    }
    const isNull = validateNullOrEmpty(payload);
    if (isNull) {
      notify("Please fill all fields", "warning", 3000);
      return;
    }
    try {
      const { data } = await axios.post("ValidateTotalHours", payload, {
        headers: {
          MappedState: 1,
        },
      });
      if (data) {
        // eslint-disable-next-line no-restricted-globals
        if (confirm(data.message)) {
          handleCallApi(payload);
        }
      } else {
        handleCallApi(payload);
      }
    } catch (error) {
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  const handleCancelRegistration = async () => {
    const payload = {
      Oid: formData.current.Oid,
      CancelReason: formData.current.CancelReason,
    };

    const isNull = validateNullOrEmpty(payload);
    if (isNull) {
      notify("Please fill all fields", "warning", 3000);
      return;
    }
    try {
      const { status } = await axios.post("CancelRegistOT", payload, {
        headers: {
          MappedState: 1,
        },
      });
      if (status !== 200) {
        notify("Registration has not been canceled", "error", 3000);
        return;
      }
      notify("Registration has been canceled", "success", 3000);
      history.push("/overtime/overtime-registration/list");
    } catch (error) {
      notify(error.response.data.message, error.response.data.msgType, 3000);
    }
  };

  const renderPopup = () => {
    return (
      <Popup
        visible={popupConfig.popupVisible}
        onHiding={handleClosePopup}
        title={formatMessage("CancelPopupTitle")}
        showTitle={true}
        width={"500px"}
        height={"200px"}
        borderRadius={10}
        closeOnOutsideClick={false}
      >
        <Form
          formData={formData.current}
          onContentReady={(e) => {
            e.component.focus();
          }}
        >
          <Item
            dataField="CancelReason"
            editorType="dxTextArea"
            colSpan={2}
            editorOptions={{
              onValueChanged: (e) => {
                formData.current.CancelReason = e.value;
              },
            }}
          >
            <Label text={formatMessage("CancelReason")} />
          </Item>
        </Form>
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleCancelRegistration}
          options={{
            icon: "save",
            type: "success",
            text: formatMessage("Save"),
          }}
        />
        <ToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          onClick={handleClosePopup}
          options={{
            icon: "close",
            type: "primary",
            text: formatMessage("Cancel"),
          }}
        />
      </Popup>
    );
  };

  return (
    <div>
      <LoadPanel visible={loading} />
      <LoadPanel visible={isLoading} />
      {loadingEmployee && <LoadPanel visible={loadingEmployee} />}
      {/* Breadcrumb */}
      <div className={"breadcrumb"}>
        <div className={"breadcrumb-left"}>
          <div className={"breadcrumb-page-title"}>
            {formatMessage("OvertimeRegistrationDetail")}
          </div>
        </div>
        <div className={"breadcrumb-right"}>
          <Link to="/overtime-registration/list" className={"breadcrumb-item"}>
            {formatMessage("Overtime")}
          </Link>
          <span className={"breadcrumb-item active"}>
            {formatMessage("OvertimeRegistration")}
          </span>
        </div>
      </div>

      <div className={"section"}>
        <div className={"section-heading has-page-title"}>
          <h4 className={"page-title"}>
            {user?.EmployeeCode + " - " + user?.EmployeeName}
          </h4>
          <div className={`page-actions`}>
            <Toolbar>
              <Item
                location="after"
                locateInMenu={isXSmall || isSmall ? "always" : "auto"}
                cssClass={"datagrid-toolbar-actions-dropdown"}
              >
                <Button
                  icon="check"
                  text={formatMessage("Save")}
                  onClick={handleSaveRegistration}
                  type="default"
                  stylingMode="outlined"
                  className="mr-2"
                />
                <Button
                  icon="close"
                  text={formatMessage("Cancel")}
                  className="mr-2"
                  onClick={() =>
                    history.push("/overtime/overtime-registration/list")
                  }
                />
                <Button
                  icon="close"
                  text={formatMessage("CancelRegistration")}
                  onClick={handleOpenPopup}
                />
              </Item>
            </Toolbar>
          </div>
        </div>
        <div className={"section-body"}>
          {popupConfig.popupVisible && renderPopup()}
          <FormComponent
            formData={formData}
            shift={shift}
            setShiftTimeIn={setShiftTimeIn}
            setShiftTimeOut={setShiftTimeOut}
            setIsAssignedShift={setIsAssignedShift}
            employee={employeesDeclarant}
            setEmployeeOid={setEmployeeOid}
            employeeOid={employeeOid}
          />
          {formData.current && (
            <EarlyLate
              formData={formData}
              setTimeIn={setShiftTimeIn}
              shiftTimeIn={shiftTimeIn}
              shiftTimeOut={shiftTimeOut}
              isAssignedShift={isAssignedShift}
            />
          )}
        </div>
      </div>
    </div>
  );
}
